import routeManifest from "../content/routes.json";
import { defaultLocale, isLocaleCode, type LocaleCode } from "./content";

const routes = new Map(routeManifest.routes.map((route) => [route.path, route]));

export function localeFromPath(pathname = currentPathname()): LocaleCode | null {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  return firstSegment && isLocaleCode(firstSegment) ? firstSegment : null;
}

export function stripLocalePrefix(pathname: string): string {
  const locale = localeFromPath(pathname);
  if (!locale) {
    return normalizePath(pathname);
  }

  const stripped = pathname.slice(`/${locale}`.length);
  return normalizePath(stripped || "/");
}

export function localizedRoute(locale: LocaleCode, path: string): string {
  const [pathnameAndQuery, hash = ""] = path.split("#", 2);
  const [pathname, query = ""] = pathnameAndQuery.split("?", 2);
  const canonicalPath = stripLocalePrefix(pathname || "/");
  const localizedPath =
    locale === defaultLocale ? canonicalPath : canonicalPath === "/" ? `/${locale}` : `/${locale}${canonicalPath}`;
  const querySuffix = query ? `?${query}` : "";
  const hashSuffix = hash ? `#${hash}` : "";

  return `${localizedPath}${querySuffix}${hashSuffix}`;
}

export function sectionForPath(pathname: string): string | null {
  const route = routes.get(stripLocalePrefix(pathname));
  return route?.sectionId && route.sectionId !== "top" ? route.sectionId : null;
}

export function isStorefrontRoute(pathname: string): boolean {
  return routes.has(stripLocalePrefix(pathname));
}

export function isStaticDocumentRoute(pathname: string): boolean {
  const route = routes.get(stripLocalePrefix(pathname));
  return Boolean(route && "legalFile" in route && route.legalFile);
}

function normalizePath(pathname: string): string {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return `/${pathname.split("/").filter(Boolean).join("/")}`;
}

function currentPathname(): string {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}
